const releaseUpdatesStyles = {
  headline: {
    marginBottom: "0.5rem"
  },
  subline: {
    marginBottom: "1rem"
  },
  editorStyle: {
    minHeight: "20rem",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "divider",
    padding: "0 1rem",
  },
  metaRow: {
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "1.5rem",
  },
  imageButton: {
    display: "block",
    width: "100%",
    borderRadius: "0.25rem",
    overflow: "hidden",
  },
  mainImage: {
    display: "block",
    width: "100%",
    maxHeight: "24rem",
    objectFit: "contain",
  },
  thumbnailRow: {
    flexWrap: "wrap",
    marginTop: "0.75rem",
  },
  thumbnailButton: {
    width: "4.5rem",
    height: "3.5rem",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "divider",
    borderRadius: "0.25rem",
    overflow: "hidden",
  },
  thumbnailImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  dialogActions: {
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "1.5rem",
    paddingTop: "1rem",
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: "divider",
  },
  archivePaper: {
    padding: "1.5rem",
    marginBottom: "1.5rem",
  },
  managementActions: {
    alignItems: "center",
    justifyContent: "space-between",
  },
  actions: {
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "1.5rem"
  },
  addMessage: {
    width: "auto",
    padding: "1rem 0"
  },
  formImage: {
    width: "7rem",
    height: "5rem",
    objectFit: "cover",
    borderRadius: "0.25rem",
  },
  formImageRow: {
    alignItems: "center",
    padding: "0.5rem",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "divider",
    borderRadius: "0.25rem",
  },
};

export default releaseUpdatesStyles;
